import messageNotificationWav from '../Assets/audio/message_notification.wav';

/**
 * Notification sound utility.
 * Uses the bundled WAV file for chat, Web Audio API chime for class.
 */

let audioContext = null;
let chatAudio = null;

function getAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
}

/**
 * Play a short, pleasant notification chime (for class started).
 */
export function playClassNotificationSound() {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;

    // Two-tone chime (ascending)
    const frequencies = [523.25, 659.25]; // C5, E5
    frequencies.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + i * 0.15);
      gain.gain.linearRampToValueAtTime(0.3, now + i * 0.15 + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.15 + 0.4);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + i * 0.15);
      osc.stop(now + i * 0.15 + 0.4);
    });
  } catch (err) {
    console.warn('[NotifSound] Failed to play class notification:', err);
  }
}

/**
 * Play a triple-tone chime for new enquiry/lead arrival.
 * Distinct from class notification — uses descending B5 → G5 → E5 triplet.
 */
export function playEnquiryNotificationSound() {
  try {
    const ctx = getAudioContext();
    const now = ctx.currentTime;

    const frequencies = [987.77, 783.99, 659.25]; // B5, G5, E5
    frequencies.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'triangle';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + i * 0.12);
      gain.gain.linearRampToValueAtTime(0.25, now + i * 0.12 + 0.04);
      gain.gain.exponentialRampToValueAtTime(0.001, now + i * 0.12 + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + i * 0.12);
      osc.stop(now + i * 0.12 + 0.35);
    });
  } catch (err) {
    console.warn('[NotifSound] Failed to play enquiry notification:', err);
  }
}

/**
 * Play the bundled WAV notification sound (for chat messages).
 */
export function playChatNotificationSound() {
  try {
    if (!chatAudio) {
      chatAudio = new Audio(messageNotificationWav);
    }
    chatAudio.currentTime = 0;
    chatAudio.volume = 0.5;
    chatAudio.play().catch(() => {});
  } catch (err) {
    console.warn('[NotifSound] Failed to play chat notification:', err);
  }
}

/**
 * Request browser notification permission.
 * Returns true if granted.
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

/**
 * Show a browser-level notification.
 */
export function showBrowserNotification(title, options = {}) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return null;
  try {
    const notif = new Notification(title, {
      icon: '/favicon.png',
      badge: '/favicon.png',
      ...options,
    });
    return notif;
  } catch (err) {
    console.warn('[BrowserNotif] Failed:', err);
    return null;
  }
}
